import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { CallWithAuth } from '../../../../../action/apiActions';
import { GET_SUBJECT_TAG } from '../../../../../action/apiPath';
import closeIcon from '../../../../../assets/images/closeSvgIcon.svg';
import style1 from '../../../../../assets/styles/modalStyle.module.css';
import style2 from '../../../../../assets/styles/testCreationStyle.module.css';

export default function TagsSearch({ ref, style, groupRules, setGroupRules, index, disabled }) {
  const organizationId = localStorage.getItem('selectedOrgId');
  const [onMouseHover, setOnMouseHover] = useState(false);
  const [multisubjectTaginput, setmultiSubjectTaginput] = useState('');
  const [multisubjectTag, setmultiSubjectTag] = useState([]);
  const [multisubjectTagStatus, setmultiSubjectTagStatus] = useState(false);
  const selectSubjectTag = (e) => {
    const data = [...groupRules];
    data[index].primary_tags.push(e);
    setGroupRules(data);
    setmultiSubjectTagStatus(false);
    setmultiSubjectTaginput('');
  };
  const TagSubjectMultiple = async (e) => {
    setmultiSubjectTaginput(e);
    if (e.length > 2) {
      const data = await CallWithAuth('GET', GET_SUBJECT_TAG + organizationId + '/?keyword=' + e);
      if (data.status && data.res.status === 200) {
        setmultiSubjectTag(data.res.data);
        if (data.res.data.length > 0) {
          setmultiSubjectTagStatus(true);
        } else {
          setmultiSubjectTagStatus(false);
        }
      }
    } else {
      setmultiSubjectTagStatus(false);
    }
  };
  const removeSubjectTag = (itemToRemove) => {
    const data = [...groupRules];
    if (data[index].primary_tags) {
      data[index].primary_tags = data[index].primary_tags.filter((tag) => tag?.id !== itemToRemove?.id);
    }
    setGroupRules(data);
  };
  return (
    <div style={{ width: '57%', position: 'relative', top: '-2px' }} className={`${style.subject} ${style2.tags}`}>
      <p style={{ fontSize: '14px', fontWeight: '500', marginTop: '0', marginBottom: '4px' }}>
        Area | Topic | Subtopic <b className={style.red_mendantory}>*</b>{' '}
      </p>
      <div className={style.search_listing} style={{ height: 'auto' }}>
        <div className={style.tag_icons}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M11.5 18C15.0899 18 18 15.0899 18 11.5C18 7.91015 15.0899 5 11.5 5C7.91015 5 5 7.91015 5 11.5C5 15.0899 7.91015 18 11.5 18Z"
              stroke="#212529"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M18.2598 19.2592L16.1406 16.8594"
              stroke="#212529"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          Tags
        </div>

        <div className={style.input_search} ref={ref} style={{ display: 'flex' }}>
          <div className={style.tag_icons} style={{ paddingRight: '0' }}>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="20" height="20" rx="4" fill="#272727" />
              <path
                d="M5.64103 10.7693H9.23072V14.359C9.23072 14.7179 9.51278 15 9.87175 15C10.2307 15 10.5128 14.7179 10.5128 14.359V10.7693H14.359C14.7179 10.7693 15 10.4872 15 10.1283C15 9.76928 14.7179 9.48722 14.359 9.48722H10.5128V5.64103C10.5128 5.28206 10.2307 5 9.87175 5C9.51278 5 9.23072 5.28206 9.23072 5.64103V9.48722H5.64103C5.28206 9.48722 5 9.76928 5 10.1283C5 10.4872 5.28206 10.7693 5.64103 10.7693Z"
                fill="white"
              />
            </svg>
          </div>
          <input
            disabled={disabled}
            type="search"
            id="searchInput"
            placeholder="Search tags"
            value={multisubjectTaginput}
            autoComplete="off"
            list="autocompleteoff"
            onBlur={() => {
              if (!onMouseHover) {
                setmultiSubjectTaginput('');
                setmultiSubjectTagStatus(false);
                // const data = [...groupRules];
                // data[index].primary_tags = [];
                // setGroupRules(data);
              }
            }}
            onChange={(e) => TagSubjectMultiple(e.target.value)}
            style={{ margin: '5px', padding: '10px', width: '97%' }}
          />

          {multisubjectTagStatus ? (
            <div
              className={style.list_input_primary}
              onMouseOver={() => {
                setOnMouseHover(true);
              }}
              onMouseLeave={() => {
                setOnMouseHover(false);
              }}
            >
              {multisubjectTag
                ?.filter((item) => !groupRules[index].primary_tags.some((filterItem) => item.id === filterItem.id))
                .map((items, i) => (
                  <>
                    <div
                      onClick={() => {
                        selectSubjectTag(items);
                        setOnMouseHover(false);
                      }}
                    >
                      <span>
                        {items.subject} | {items.area} | {items.topic} | {items.subtopic}{' '}
                      </span>
                    </div>
                  </>
                ))}
            </div>
          ) : (
            ''
          )}
        </div>
      </div>
      {groupRules[index]?.primary_tags?.map((items, i) => (
        <div className={`${style.subjectWrap} ${style.subjectWrapPosition} ${style1.slelectedItems}`} key={items + i}>
          <span
            title={`${items.subject} | ${items.area} | ${items.topic} | ${items.subtopic} `}
            className={`${style.selected_tags} ${style.selected_tags_bg_reomve}`}
          >
            {items?.subject} | {items?.area} | {items?.topic} | {items?.subtopic}
          </span>
          <button className={style1.crossbutton} onClick={() => removeSubjectTag(items)}>
            <img src={closeIcon} alt="Close" />
          </button>
        </div>
      ))}
    </div>
  );
}

TagsSearch.propTypes = {
  groupRules: PropTypes.any,
  index: PropTypes.any,
  ref: PropTypes.any,
  setGroupRules: PropTypes.any,
  style: PropTypes.shape({
    cancel_button: PropTypes.any,
    input_search: PropTypes.any,
    list_input_primary: PropTypes.any,
    red_mendantory: PropTypes.any,
    search_listing: PropTypes.any,
    selected_tags: PropTypes.any,
    selected_tags_bg_reomve: PropTypes.any,
    subject: PropTypes.any,
    subjectWrap: PropTypes.any,
    subjectWrapPosition: PropTypes.any,
    tag_icons: PropTypes.any,
  }),
};
